import { Pipe, PipeTransform } from '@angular/core';
import { Injectable } from '@angular/core';

@Pipe({
  name: 'truncateNumber'
})
@Injectable()
export class TruncateNumberPipe implements PipeTransform {
  transform(nb: number) {
    return Math.trunc(nb);
  }
}
